var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35403 2.64597L11.354 7.64597C11.4005 7.69241 11.4374 7.74755 11.4626 7.80825C11.4877 7.86895 11.5007 7.93401 11.5007 7.99972C11.5007 8.06543 11.4877 8.13049 11.4626 8.19119C11.4374 8.25189 11.4005 8.30704 11.354 8.35347L6.35403 13.3535C6.26021 13.4473 6.13296 13.5 6.00028 13.5C5.8676 13.5 5.74035 13.4473 5.64653 13.3535C5.55271 13.2597 5.5 13.1324 5.5 12.9997C5.5 12.867 5.55271 12.7398 5.64653 12.646L10.2934 7.99972L5.64653 3.35347C5.60007 3.30702 5.56322 3.25187 5.53808 3.19117C5.51294 3.13047 5.5 3.06542 5.5 2.99972C5.5 2.93402 5.51294 2.86897 5.53808 2.80827C5.56322 2.74758 5.60007 2.69243 5.64653 2.64597C5.69298 2.59952 5.74813 2.56267 5.80883 2.53753C5.86953 2.51238 5.93458 2.49944 6.00028 2.49944C6.06598 2.49944 6.13103 2.51238 6.19173 2.53753C6.25242 2.56267 6.30757 2.59952 6.35403 2.64597Z",
    fill: "#545A66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/CaretDown.63d86f28c630bce9b27e0d61d1f6fcda.svg";
export { ForwardRef as ReactComponent };